import { Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap, map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { SvgRegistry } from './svg-registry';

@Component({
  selector: 'ntt-svg',
  template: ``,
  host: {
    '[innerHTML]': 'sanitizedSvg()',
  },
})
export class NttSvg {
  private readonly _registry = inject(SvgRegistry);
  private readonly _sanitizer = inject(DomSanitizer);

  readonly name = input.required<string>();

  private readonly _name$ = toObservable(this.name);
  private readonly _svg$ = this._name$.pipe(
    switchMap((name) => this._registry.get(name)),
    map((svg) => this._sanitizer.bypassSecurityTrustHtml(svg)),
  );

  protected readonly sanitizedSvg = toSignal(this._svg$, {
    initialValue: this._sanitizer.bypassSecurityTrustHtml(''),
  });
}
